module.exports = __webpack_public_path__ + "static/img/waiguanshejizhuanli.7b2b6ef3.jpg";